// extracted by mini-css-extract-plugin
module.exports = {"beachHouseSlider":"style_beachHouseSlider__CbEjX","beachSliderImage":"style_beachSliderImage__oYb4R","beachHouseArrow":"style_beachHouseArrow__cSCvb"};